import { Link } from '@tanstack/react-router';
import Logo from '../ui/logo';

const linkBase = 'inline-flex h-9 items-center rounded-lg px-4 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring';

export function NotFoundPage() {
  const isVideo = typeof window !== 'undefined' && window.location.pathname.startsWith('/chat/');
  return (
    <main className="flex min-h-full flex-col bg-background px-4 py-6 text-foreground sm:px-8">
      <Link to="/" search={{ slide: undefined }} aria-label="4K Labs home" className="self-start">
        <Logo variant="compact" />
      </Link>
      <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center gap-3 pb-16">
        <h1 className="text-2xl font-semibold tracking-tight">
          {isVideo ? "We couldn't open this video" : "This page doesn't exist"}
        </h1>
        <p className="text-[15px] leading-6 text-muted-foreground">
          {isVideo
            ? 'It may have been deleted, or it belongs to another account. If someone shared it with you, ask them for a new link.'
            : 'The link may be mistyped, or the page has moved.'}
        </p>
        <div className="mt-2 flex flex-wrap gap-2">
          {isVideo && (
            <Link to="/videos" className={`${linkBase} bg-primary text-primary-foreground hover:bg-primary/90`}>
              Your videos
            </Link>
          )}
          <Link to="/" search={{ slide: undefined }} className={`${linkBase} ${isVideo ? 'border border-border hover:bg-muted' : 'bg-primary text-primary-foreground hover:bg-primary/90'}`}>
            Go to Home
          </Link>
        </div>
      </div>
    </main>
  );
}
